import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/fr';

// Add any plugins you want to use with Day.js
import utc from 'dayjs/plugin/utc';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import CustomParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(utc);
dayjs.extend(weekOfYear);
dayjs.extend(LocalizedFormat);
dayjs.extend(CustomParseFormat);

export default dayjs;
export { weekOfYear };
